<div class="row">
  <spinner [id]="'summary'" [show]='activeSpinner'></spinner>

  <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <div class="form-group d-flex flex-row bd-highlight mb-3">
      <label style="line-height: 240%;">{{'header.assesmentyear' | translate }}</label>
      <select style="width: 150px; margin-left: 20px;" [(ngModel)]="assesmentyear" class="form-control custom-selectbox" (change)="getDataForPieChart()">
        <option value="" [disabled]="true">{{'header.assesmentyear' | translate }}</option>
        <option *ngFor="let year of AssesmentList" value="{{year}}">{{year}}</option>
      </select>
    </div> -->
            <!-- <span style="color:red" [hidden]="validation[0]">Please Select Assessment Year </span> -->
  <!-- </div> -->
  
  <div class="row">
    <div class="col-md-2">
      <pie-chart  *ngIf="totalstateschartdata != null" [chartData]="totalstateschartdata" [chartId]="'pieChart'">
      </pie-chart>
    </div>
    <div class="col-md-2">
      <pie-chart *ngIf="nonhimchartdata != null" [chartData]="nonhimchartdata" [chartId]="'nonhimpiechart'">
      </pie-chart>
    </div>
    <div class="col-md-2">
      <pie-chart *ngIf="himchartdata != null" [chartData]="himchartdata" [chartId]="'himchart'">
      </pie-chart>
    </div>
    <div class="col-md-2">
      <pie-chart *ngIf="unionchartdata != null" [chartData]="unionchartdata" [chartId]="'unionchart'">
      </pie-chart>
    </div>
  </div>
</div>


